module.exports = __webpack_public_path__ + "img/FachadaBristol-1.40fc4319.jpg";